export default "__VITE_ASSET__B$4lDe93__"